import { useEffect, useState } from "react";
import styled from "styled-components";

import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import ListBuildingContainer from "./ListBuildingContainer";
import TutorialBox from "components/other/TutorialBox";

const MarketingTools = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

export default () => {
  const [createPageBox, setCreatePageBox] = useState(false);

  // set page Title
  useEffect(() => {
    document.title = "Marketing Tools | Scalelup";
  }, []);

  const closeTutorialBox = () => {
    setCreatePageBox(false);

    localStorage.setItem("closed-create-page-t-box", "y");
  };

  useEffect(() => {
    const closedBox = localStorage.getItem("closed-create-page-t-box");

    if (!closedBox) setCreatePageBox(true);
    else setCreatePageBox(false);
  }, []);

  return (
    <Layout>
      <MarketingTools>
        {createPageBox && (
          <TutorialBox
            title="Design Your Landing Page"
            text="Create a Lead Capture Landing Page, direct your traffic to it, and collect valuable leads. Choose from a variety of fully customizable pages. It’s completely free!"
            closeBox={closeTutorialBox}
            buttonTo="/landing-page-templates"
            buttonText="Create New Page"
            callback={() => {
              localStorage.setItem("closed-create-page-t-box", "y");
            }}
          />
        )}
        <PageTitle>Marketing Tools</PageTitle>
        <ListBuildingContainer />
      </MarketingTools>
    </Layout>
  );
};
